import type { Department, DepartmentWithCount } from "@/interfaces/department";
import { httpClient } from "@/lib/api";

export type ListDepartmentsResponse = {
  data: Department[];
};

export type CreateDepartmentPayload = {
  name: string;
  color: string;
};

export type UpdateDepartmentPayload = Partial<CreateDepartmentPayload>;

export type ListDepartmentsWithCountResponse = {
  data: DepartmentWithCount[];
};

export class DepartmentService {

  public static async list() {
    const { data } = await httpClient().get<ListDepartmentsResponse>("/department");
    return data.data;
  }
  
  public static async listWithRelationsCount() {
    const { data } = await httpClient().get<ListDepartmentsWithCountResponse>("/department/list");
    return data.data;
  }
  
  public static async create(payload: CreateDepartmentPayload) {
    const { data } = await httpClient().post<DepartmentWithCount>("/department", payload);
    return data;
  }

  public static async update(id: number, payload: UpdateDepartmentPayload) {
    const { data } = await httpClient().patch<DepartmentWithCount>(`/department/${id}`, payload);
    return data;
  }
  
  public static async delete(id: number) {
    const { data } = await httpClient().delete(`/department/${id}`);
    return data;
  }

  public static async assignAsDefault(id: number) {
    const { data } = await httpClient().post(`/department/${id}/default`);
    return data;
  }
}
